






import { Vue, Prop, Component } from 'vue-property-decorator'
@Component
export default class Buttons extends Vue {
    // Prop => Datas envoyée depuis le composent parent à l'enfant (ici)
    @Prop() public title!: string
    @Prop() public subTitle!: string
}
